import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import VConsole from "vconsole";
import "animate.css";
import "hover.css/css/hover-min.css";
import "./style/global.less"; // 引入全局 Less 文件
import "./style/variables.less";
import { onWindowResize } from "@/utils/help";

createApp(App).use(store).use(router).use(Antd).use(Vant).mount("#app");

if (
  process.env.NODE_ENV !== "production" &&
  window.document.body.clientWidth - 1 < 1200
) {
  new VConsole();
}
// 窗口大小变化 自动刷新
onWindowResize(({ width, oldWidth }) => {
  // 设备变化的时候再刷新
  if (
    (oldWidth > 1200 && width <= 1200) ||
    (oldWidth <= 1200 && width > 1200)
  ) {
    window.location.reload();
  }
});
